<template>
  <div class="container py-24">
    <div class="mb-12 text-center">
      <h1 class="mb-4 text-4xl font-bold text-foreground">Legal</h1>
      <p class="mx-auto max-w-xl text-muted-foreground">
        All of our legal documents are available below. Select any document to read it in full.
      </p>
    </div>
    <div class="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
      <NuxtLink :to="$localePath('/legal/legal-notice')" class="group rounded-2xl border border-border bg-card p-6 transition-all hover:border-primary hover:shadow-md">
        <h2 class="mb-2 text-xl font-semibold group-hover:text-primary">
          {{ $ts('landing.footer.legalNotice') }}
        </h2>
        <p class="text-sm text-muted-foreground">Company information and legal entity details (Impressum).</p>
      </NuxtLink>

      <NuxtLink :to="$localePath('/legal/privacy-policy')" class="group rounded-2xl border border-border bg-card p-6 transition-all hover:border-primary hover:shadow-md">
        <h2 class="mb-2 text-xl font-semibold group-hover:text-primary">
          {{ $ts('landing.footer.privacyPolicy') }}
        </h2>
        <p class="text-sm text-muted-foreground">How we collect, use, store, and protect your personal data.</p>
      </NuxtLink>

      <NuxtLink :to="$localePath('/legal/cookie-policy')" class="group rounded-2xl border border-border bg-card p-6 transition-all hover:border-primary hover:shadow-md">
        <h2 class="mb-2 text-xl font-semibold group-hover:text-primary">
          {{ $ts('landing.footer.cookiePolicy') }}
        </h2>
        <p class="text-sm text-muted-foreground">Information about how we use cookies and tracking technologies.</p>
      </NuxtLink>

      <NuxtLink :to="$localePath('/legal/terms-and-conditions')" class="group rounded-2xl border border-border bg-card p-6 transition-all hover:border-primary hover:shadow-md">
        <h2 class="mb-2 text-xl font-semibold group-hover:text-primary">
          Terms & Conditions
        </h2>
        <p class="text-sm text-muted-foreground">Terms for pet owners, businesses, specialists, and marketplace purchases.</p>
      </NuxtLink>

      <NuxtLink :to="$localePath('/legal/refund-and-cancellation')" class="group rounded-2xl border border-border bg-card p-6 transition-all hover:border-primary hover:shadow-md">
        <h2 class="mb-2 text-xl font-semibold group-hover:text-primary">
          Refund & Cancellation Policy
        </h2>
        <p class="text-sm text-muted-foreground">Cancellation rights, refund process, and your statutory withdrawal right.</p>
      </NuxtLink>

      <NuxtLink :to="$localePath('/legal/withdrawal-form')" class="group rounded-2xl border border-border bg-card p-6 transition-all hover:border-primary hover:shadow-md">
        <h2 class="mb-2 text-xl font-semibold group-hover:text-primary">
          Model Withdrawal Form
        </h2>
        <p class="text-sm text-muted-foreground">Printable statutory withdrawal form per the Consumer Rights Directive.</p>
      </NuxtLink>

      <NuxtLink :to="$localePath('/legal/gdpr')" class="group rounded-2xl border border-border bg-card p-6 transition-all hover:border-primary hover:shadow-md">
        <h2 class="mb-2 text-xl font-semibold group-hover:text-primary">
          Your Data Rights (GDPR)
        </h2>
        <p class="text-sm text-muted-foreground">How to exercise your data protection rights under EU law.</p>
      </NuxtLink>

      <NuxtLink :to="$localePath('/legal/reviews-and-ratings')" class="group rounded-2xl border border-border bg-card p-6 transition-all hover:border-primary hover:shadow-md">
        <h2 class="mb-2 text-xl font-semibold group-hover:text-primary">
          Reviews & Ratings Policy
        </h2>
        <p class="text-sm text-muted-foreground">How reviews are verified, moderated, and displayed on the platform.</p>
      </NuxtLink>

      <NuxtLink :to="$localePath('/legal/dsa')" class="group rounded-2xl border border-border bg-card p-6 transition-all hover:border-primary hover:shadow-md">
        <h2 class="mb-2 text-xl font-semibold group-hover:text-primary">
          DSA Transparency
        </h2>
        <p class="text-sm text-muted-foreground">Digital Services Act compliance, content moderation, and reporting.</p>
      </NuxtLink>

      <NuxtLink :to="$localePath('/legal/security')" class="group rounded-2xl border border-border bg-card p-6 transition-all hover:border-primary hover:shadow-md">
        <h2 class="mb-2 text-xl font-semibold group-hover:text-primary">
          Security Policy
        </h2>
        <p class="text-sm text-muted-foreground">How we protect your data and our security practices.</p>
      </NuxtLink>

      <NuxtLink :to="$localePath('/legal/accessibility')" class="group rounded-2xl border border-border bg-card p-6 transition-all hover:border-primary hover:shadow-md">
        <h2 class="mb-2 text-xl font-semibold group-hover:text-primary">
          Accessibility Statement
        </h2>
        <p class="text-sm text-muted-foreground">Our commitment to digital accessibility for all users.</p>
      </NuxtLink>

      <NuxtLink :to="$localePath('/legal/data-processing')" class="group rounded-2xl border border-border bg-card p-6 transition-all hover:border-primary hover:shadow-md">
        <h2 class="mb-2 text-xl font-semibold group-hover:text-primary">
          Data Processing Agreement
        </h2>
        <p class="text-sm text-muted-foreground">How we process personal data and our sub-processor relationships.</p>
      </NuxtLink>

      <NuxtLink :to="$localePath('/legal/ai-transparency')" class="group rounded-2xl border border-border bg-card p-6 transition-all hover:border-primary hover:shadow-md">
        <h2 class="mb-2 text-xl font-semibold group-hover:text-primary">
          AI Transparency Disclosure
        </h2>
        <p class="text-sm text-muted-foreground">How we use artificial intelligence, EU AI Act compliance.</p>
      </NuxtLink>

    </div>
  </div>
</template>

<script setup lang="ts">
import { definePageMeta, useI18n, useSeoMeta } from '#imports';

definePageMeta({
  layout: 'default',
});

const { $ts, $localePath } = useI18n();

useSeoMeta({
  title: () => $ts('legal.seo.title'),
  description: () => $ts('legal.seo.description'),
});
</script>
